export const init = () => {
  initImagesSlider();

  if ($('#video-slider').find('.vjs-cube').length)
    import(/* webpackChunkName: "videojs" */ 'video.js')
      .then(initVideoJs)
      .then(initVideosSlider);
};

const initImagesSlider = () => {
  const $imageSlider = $('#image-slider');
  const $imageList = $('#image-list');

  $imageSlider.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    fade: true,
    asNavFor: $imageList.selector,
  });

  $imageList.slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    variableWidth: true,
    focusOnSelect: true,
    asNavFor: $imageSlider.selector,
  });
};

// Called after dynamic import of 'video.js'
// -- videojs is passed as argument
// Promise is resolved when all videos are inited
const initVideoJs = videojs => {
  const $videos = $('#video-list .vjs-cube');
  const videoToLoad = $videos.length;
  let countLoaded = 0;
  const options = {
    controlBar: { volumeMenuButton: { inline: false, vertical: true } },
  };

  return new Promise(resolve => {
    $.each($videos, (index, video) => {
      // Init videojs for each video on page
      videojs($(video).attr('id'), options, () => {
        countLoaded += 1;
        // When all inited : launch Slick init
        if (countLoaded === videoToLoad) resolve();
      });
    });
  });
};

// Init video sliders
// Bind click event to stop video
const initVideosSlider = () => {
  const $videoSlider = $('#video-slider');
  const $videoList = $('#video-list');

  $videoSlider.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    fade: true,
    asNavFor: $videoList.selector,
  });

  $videoList.slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    variableWidth: true,
    focusOnSelect: true,
    asNavFor: $videoSlider.selector,
  });

  // Bind events
  const $thumbnails = $videoList.find('picture');
  const $player = $('.vjs-tech');

  $thumbnails.on('click', stopVideo($videoSlider));
  $player.on('click', stopVideo($videoSlider));
};

// Pass a $videoSlider to set context, then returned a callback function
// this : clickElement.on('click', stopVideo(videoSlider))
// is like : stopVideo(slider)(clickEvent)
const stopVideo = $videoSlider =>
  function stopVideoCallback() {
    if (!$(this).hasClass('slick-current'))
      $videoSlider.find('.vjs-play-control.vjs-playing').trigger('click');
  };



// WEBPACK FOOTER //
// ./src/workshop/workshop-product-page.js